import { render, staticRenderFns } from "./ProductLayout.vue?vue&type=template&id=64e2576c&scoped=true"
import script from "./ProductLayout.vue?vue&type=script&lang=js"
export * from "./ProductLayout.vue?vue&type=script&lang=js"
import style0 from "./ProductLayout.vue?vue&type=style&index=0&id=64e2576c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2576c",
  null
  
)

export default component.exports